import React, { useState, useEffect } from 'react';
import { Button, Form, Modal, Col, Row } from 'react-bootstrap';
import { apiFetch } from '../services/apiService';
import ModalEditNews from './ModalEditNews';
import { useAuth } from '../contexts/AuthContext';

const NewsList = ({novinky, fetchAllNews}) => {
    const { user } = useAuth();

    return (
        <div>
            {novinky.map(novinka => (
                <div key={novinka._id} className='p-3 border-success border-bottom mb-3 text-start'>
                    <header className='align-items-center d-flex'>
                        <h2 className='display-6 fs-2'>{novinka.title}</h2>
                        {user && <ModalEditNews novinka={novinka} fetchAllNews={fetchAllNews}/>}
                    </header>
                    
                    
                    <p dangerouslySetInnerHTML={{ __html: novinka.content }}></p>
                    {/* Další detaily novinky */}
                    
                    
                </div>
            ))}
        </div>
    );
}

export default NewsList;